import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const HeroSection = () => {
  return (
    <section
          id='inicio'
          className='position-relative overflow-hidden'
          style={{
            background: "linear-gradient(135deg, #182848 0%, #4b6cb7 100%)",
            color: "white",
            minHeight: "calc(100vh - 70px)",
            padding: "80px 0",
          }}
        >
          <Container className='position-relative h-100'>
            <Row className='align-items-center h-100'>
              <Col lg={6} className='pe-lg-5'>
                <Badge bg='warning' text='dark' className='mb-3 fw-normal fs-6'>
                  SERVICIO EXPRESS
                </Badge>
                <h1 className='display-4 fw-bold mb-4'>
                  Recibí tus compras internacionales <br />
                  <span className='text-warning'>fácil y rápido</span> con MBOX
                </h1>
                <p className='lead mb-4 opacity-75'>
                  Desde Miami hasta la puerta de tu casa en Honduras.
                </p>
                <div className='d-flex gap-3 mt-4 flex-wrap'>
                  <Button
                    size='lg'
                    variant='warning'
                    className='fw-bold shadow'
                    target='_blank'
                    rel='noreferrer'
                    href='https://mbox-hn.com/crear-casillero'
                    style={{
                      borderRadius: "12px",
                      padding: "12px 24px",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-3px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    Crear mi Casillero
                  </Button>
                  <Button
                    size='lg'
                    variant='outline-light'
                    href='https://wa.me/50498744314?text=Hola%2C+quiero+informaci%C3%B3n+sobre+env%C3%ADos'
                    target='_blank'
                    rel='noreferrer'
                    className='d-flex align-items-center shadow'
                    style={{
                      borderRadius: "12px",
                      padding: "12px 24px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.backgroundColor =
                        "rgba(255,255,255,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <FaWhatsapp size={20} className='me-2' />
                    Contactar Agente
                  </Button>
                </div>

                <div className='mt-5 d-flex flex-wrap gap-4'>
                  <div className='d-flex align-items-center'>
                    <FaShippingFast size={24} className='text-warning me-2' />
                    <div>
                      <div className='fw-bold'>Envios rápidos</div>
                      <small className='text-white-50'>3-5 días hábiles</small>
                    </div>
                  </div>
                  <div className='d-flex align-items-center'>
                    <div
                      className='text-warning me-2'
                      style={{ width: "24px" }}
                    >
                      <Player
                        autoplay
                        oop
                        src={boxAnimation}
                        style={{ height: "100%", width: "100%" }}
                      />
                    </div>
                    <div>
                      <div className='fw-bold'>Reempaque gratis</div>
                      <small className='text-white-50'>Ahorra en volumen</small>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={6} className='mt-4 mt-lg-0'>
                <div className='position-relative'>
                  <motion.img
                    src={inicio}
                    alt='envío internacional'
                    className='img-fluid rounded-4 shadow-lg'
                    initial={{ opacity: 0, y: 50, rotateY: -15 }}
                    animate={{ opacity: 1, y: 0, rotateY: -10 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    style={{
                      border: "4px solid rgba(255, 255, 255, 0.2)",
                      transform: "perspective(1000px)",
                      transition: "transform 0.5s ease",
                      maxHeight: "500px",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(-5deg) scale(1.02)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(-10deg) scale(1)")
                    }
                  />

                  <div
                    className='position-absolute top-0 start-0 w-100 h-100 rounded-4'
                    style={{
                      background:
                        "linear-gradient(45deg, rgba(245,166,35,0.2) 0%, rgba(24,40,72,0.2) 100%)",
                      zIndex: -1,
                      transform: "translate(20px, 20px)",
                    }}
                  ></div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default HeroSection;
